/**
 * If a promise producing function is called while a previous promise is still pending, returns the same promise instead of calling the function again.
 * @param fn - a function that returns a promise
 * @returns a function that wraps the original function with deduplication logic
 */
export function dedupeAsync<T>(fn: () => Promise<T>): () => Promise<T> {
  let inFlight: Promise<T> | null = null;
  return async () => {
    if (inFlight) {
      return inFlight;
    }
    inFlight = fn();
    try {
      return await inFlight;
    } finally {
      inFlight = null;
    }
  };
}
